// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6c6da237","703":"c4b87f3b"}[chunkId] + ".chunk.js";
};